import { Event, Type as EventType } from './events.js';
import { getProviders } from './providers.js';

const ebus = {
    /* eslint-disable-next-line */
    init: () => { window.EBus = window.EBus || [] },
    /* eslint-disable-next-line */
    track: e => window.EBus.push(e),
};

// TODO function GetProviders
let providers = [];
let page = null;
const initialize = (config) => {
    page = config.page;
    providers = getProviders(config);
    ebus.init();
};

const track = (type, action, label) => {
    if (typeof type == 'object' && !action) return ebus.track(type);

    let ev, evi;
    Object.keys(Event).forEach(k => {
        ev = Event[k];
        if (type & ev.type) {
            evi = ev.create(action, page, label);
            providers.forEach(p => p.track(evi));
        }
    });
};


export {
    initialize,
    EventType,
    track,
};
